import { App } from '../../../../base/AppContext';

const { server } = App;
export const updateProfile = async (profile) => {
  return await server.call('updateProfile', profile);
};
